import { SubmitPayload } from '../types';
import {BACKEND_API_URL} from "../config";

export class Api {
    public getTemplates = async () => {
        const response = await fetch(`${BACKEND_API_URL}/template/images`);
        return (await response.json()).data;
    };

    public submitOrder = async (payload: SubmitPayload) => {
        const form = new FormData();

        form.append('comment', payload.name);
        form.append('phoneNumber', payload.phone);
        form.append('count', String(payload.count));
        form.append('magnetCount', String(payload.magnetCount));

        form.append('file', payload.file, payload.file.name || 'card.png');

        const res = await fetch(`${BACKEND_API_URL}/template/create`, {
            method: 'POST',
            body: form,
        });

        const data = await res.json().catch(() => null);

        if (!res.ok) {
            throw new Error(data?.message || 'Submit failed');
        }

        return data as { success: boolean };
    };
}

export const api = new Api();
